import { isBrowser } from '@/lib/window';

import { Colors } from '@/styles/types';

export const defaultTheme = 'light' as const;
export const themes = ['light', 'dark', 'decodo-light', 'decodo-dark'] as const;
export type Themes = (typeof themes)[number];
export type StrapiThemes = {
  id: number;
  themeKey: Themes;
};

export function setTheme(theme: Themes) {
  localStorage.setItem('theme', theme);
}

export function removeTheme() {
  localStorage.removeItem('theme');
}

export function checkTheme(theme: Themes) {
  if (!isBrowser) return false;

  return (
    localStorage.getItem('theme') === theme ||
    (!('theme' in localStorage) &&
      window.matchMedia(`(prefers-color-scheme: ${theme})`).matches)
  );
}

export function getCurrentTheme() {
  // ? this way because if we want to add later more themes, we can easily remove condition
  return checkTheme('dark') ? 'dark' : 'light';
}

export function getCurrentThemeColor(): Colors {
  const themeMainColor = {
    light: 'neutral-N00',
    dark: 'neutral-N99',
  } as const;

  return themeMainColor[getCurrentTheme()];
}

export function findElClosestTheme(el?: HTMLElement) {
  if (!el) return;

  const selector = themes.map((theme) => `.${theme}`).join(',');

  const closest = el.closest(selector);
  if (!closest) return;

  return themes.find((theme) => closest.classList.contains(theme));
}
